import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { DELETE_CURRENT_LIST, EXPORT_LIST_CONTACTS, DELETE_ALL_LIST_CONTACTS } from "../../../store/marketing/marketing-actions";
import ButtonBar from "@Shared/components/general/button-bar";
import ConfirmDeleteListModal from "../modals/confirm-delete-list-modal";
import ConfirmDeleteSegmentModal from "../modals/confirm-delete-segment-modal";
import ConfirmDeleteContactsModal from "../modals/confirm-delete-contacts-modal";
import { showToast } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentHeader",
  components: {
    ConfirmDeleteListModal,
    ConfirmDeleteSegmentModal,
    ConfirmDeleteContactsModal,
    ButtonBar
  },
  props: {
    title: {
      type: String,
      required: true
    },
    listId: {
      type: String,
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    currentSegment: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      deleteList: {
        loading: false,
        success: false
      },
      deleteSegment: {
        loading: false,
        success: false
      },
      deletingAllContacts: {
        loading: false,
        status: true
      }
    };
  },
  computed: {
    backLink() {
      return {
        name: "marketing-list"
      };
    },
    currentTabIsASegment() {
      const nonSegmentsTabs = ["all", "add"];
      return !_includesInstanceProperty(nonSegmentsTabs).call(nonSegmentsTabs, this.currentTab);
    },
    exportContactsText() {
      return this.currentTabIsASegment ? this.$t("lists.segments.exportSegment") : this.$t("lists.segments.exportContacts");
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("MarketingStore", [DELETE_CURRENT_LIST, EXPORT_LIST_CONTACTS, DELETE_ALL_LIST_CONTACTS])), {}, {
    toggleManageContacts() {
      this.showManageContacts = !this.showManageContacts;
    },
    hideManageContacts() {
      this.showManageContacts = false;
    },
    toViewContacts() {
      this.$emit("segment-change", "all");
    },
    toViewDetails() {
      this.$router.push({
        path: `/marketing/lists/${this.listId}`
      });
    },
    toImportContacts() {
      this.$router.push({
        path: `/marketing/lists/${this.listId}/contacts/import`
      });
    },
    exportContacts() {
      this.EXPORT_LIST_CONTACTS({
        listId: this.listId,
        segmentId: this.currentTabIsASegment ? this.currentSegment.id : null
      });
    },
    showDeleteContactsModal() {
      this.$refs.confirmDeleteContactsModal.showModal();
    },
    showDeleteListModal() {
      this.$refs.confirmDeleteListModal.show();
    },
    showDeleteSegmentModal() {
      this.$refs.confirmDeleteSegmentModal.show();
    },
    hideDeleteSegmentModal() {
      this.$refs.confirmDeleteSegmentModal.hide();
    },
    async deleteContacts() {
      try {
        this.deletingAllContacts.loading = true;
        await this.DELETE_ALL_LIST_CONTACTS(this.listId);
        this.$emit("delete-contacts");
      } catch (e) {
        this.deletingAllContacts.status = false;
      } finally {
        this.$refs.confirmDeleteContactsModal.hideModal();
        this.deletingAllContacts.loading = false;
      }
    },
    async handleDeleteList() {
      this.deleteList.loading = true;
      await this.DELETE_CURRENT_LIST(this.listId);
      this.$router.replace({
        path: "/marketing/lists"
      });
      this.deleteList.success = true;
      this.deleteList.loading = false;
    },
    handleDeleteSegment() {
      this.deleteSegment.loading = true;
      this.$emit("delete-current-segment", () => this.finishDeleteSegment());
    },
    finishDeleteSegment() {
      this.deleteSegment.success = true;
      this.deleteSegment.loading = false;
      this.hideDeleteSegmentModal();
      showToast("success", "segmentDeleted");
    }
  })
});